function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5117 11.3864L19.9343 7.11734C20.0219 7.03249 20.0219 6.87604 19.9343 6.79119L15.5117 2.52482C15.485 2.49869 15.4524 2.48192 15.4176 2.47651C15.3829 2.4711 15.3476 2.47728 15.3158 2.49431C15.284 2.51134 15.2572 2.53851 15.2384 2.57259C15.2196 2.60667 15.2098 2.64623 15.21 2.68657V4.3491C15.21 4.41274 15.233 4.47107 15.2768 4.51085L17.8059 6.95559L15.2768 9.40034C15.2562 9.42018 15.2395 9.4449 15.228 9.47281C15.2165 9.50073 15.2103 9.53118 15.21 9.56208V11.2246C15.21 11.4049 15.3919 11.503 15.5117 11.3864Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.48828 2.61364L0.0656681 6.88266C-0.021863 6.96751 -0.021863 7.12396 0.0656681 7.20881L4.48828 11.4752C4.51498 11.5013 4.54764 11.5181 4.58237 11.5235C4.6171 11.5289 4.65245 11.5227 4.68422 11.5057C4.71599 11.4887 4.74285 11.4615 4.7616 11.4274C4.78036 11.3933 4.79023 11.3538 4.79004 11.3134V9.6509C4.79004 9.58726 4.767 9.52893 4.72324 9.48915L2.19405 7.04441L4.72324 4.59966C4.74383 4.57982 4.76045 4.5551 4.77198 4.52719C4.78351 4.49927 4.78967 4.46882 4.79004 4.43792V2.77538C4.79004 2.59508 4.60806 2.49697 4.48828 2.61364Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.4438 13.7858C7.16062 13.6696 7.02378 13.3471 7.13701 13.0627L12.1293 0.524225C12.2442 0.235596 12.5726 0.0962686 12.86 0.214207C13.1432 0.33041 13.2801 0.65294 13.1668 0.937322L8.17453 13.4758C8.05961 13.7644 7.73121 13.9037 7.4438 13.7858Z",
  fill: "currentColor"
});

var SvgIcCode = function SvgIcCode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_code.5176ca80.svg";
export { ForwardRef as ReactComponent };